import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step, { StepProps } from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { styled, SxProps, useMediaQuery } from '@mui/material';
import { colors } from '../../constants/colors';


// TABS
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import clsx from 'clsx';

type modeProps = 'tab' | 'normal';


interface TabsCustomProps {
    mode?: modeProps
}
const TabsCustom = styled(Tabs, {
    shouldForwardProp: (prop) => prop !== "mode",
})<TabsCustomProps>(({ mode }) => ({
    height: "100%",
    "& .MuiTab-root": {
        color: mode === "tab" ? "#4a4a4a" : colors.textNormal,
        backgroundColor: mode === "tab" ? "#fff" : "transparent",
        transition: "all .3s ease",
        minHeight: 0,
        borderRadius: mode === "tab" ? "4px" : "200px",
    },
    "& .MuiTab-root:hover": {
        backgroundColor: mode === "tab" ? "#f7f7f7" : colors.subPrimary,
    },
    "& .MuiButtonBase-root.MuiTab-root.Mui-selected": {
        borderRadius: mode === "tab" ? "4px" : "200px",
        backgroundColor: mode === "tab" ? "#9E640E !important" : colors.subPrimary,
        color: mode === "tab" ? colors.white : colors.white,
    },
    "& .MuiTab-root:focus": {
        outline: "none",
    },
    "& .MuiTab-root:active": {
        transform: "scale(0.97)", 
    },
}));


function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

interface CustomStepProps extends StepProps {
    step: number;
    index: number;
}

const MainStepper = styled(Stepper)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: 1000,
    margin: '0 auto',
    padding: theme.spacing(2, 0),
    '& .MuiStepConnector-line': {
        borderColor: 'currentColor',
        borderTopStyle: 'dotted',
        borderTopImageSlice: 10,
        borderTopImage: 'linear-gradient(to right, currentColor 33%, rgba(255, 255, 255, 0) 0%)',
    },
    "& .MuiStepLabel-root .Mui-completed": {
        color: colors.success3
    },
    "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
        color: "blue"
    },
    "& .MuiStepLabel-root .Mui-active": {
        color: colors.subPrimary
    },
    "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
        color: colors.success3,
    },
    "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
        fill: colors.white
    },
    '& .MuiStepLabel-label': {
        marginTop: "8px !important"
    },
    // '& .MuiStepIcon-root': {
    //     color: colors.subPrimary,
    // },
}))
const CustomStep = styled((props: CustomStepProps) => (
    <Step {...props} />
))(({ theme, step, index }) => ({
    textTransform: "none",
    '& .MuiStepIcon-root': {

    },
}));

const CustomStepLabel = styled(StepLabel)({
    display: 'flex',
    flexDirection: 'column',
    cursor: "pointer !important",
})

export type stepLabelType = {
    name: string,
    isAccept: boolean,
    icon?: React.ReactNode | any,
    disabled?: boolean;
    iconOther?: React.ReactNode;

}
type Props = {
    step: number;
    stepLabel: stepLabelType[];
    setStep: (num: number) => void;
    view?: boolean;
    maxWidthScroll?: string;
    sx?: SxProps;
    mode?: modeProps
}

const StepperCustom: React.FC<Props> = React.memo((props: Props) => {
    const { step, stepLabel, setStep, view, mode, maxWidthScroll } = props;
    const matchScreen: boolean = useMediaQuery(`(min-width:${maxWidthScroll ? maxWidthScroll : '1440px'})`);

    const handleChangeViewStep = (event: React.SyntheticEvent, newValue: number) => {
        setStep(newValue);
    };

    return (
        <Box className="w-full" sx={{ width: 'auto', my: 2 }}>
            {view ? (
                <Box sx={{ width: 'auto' }}>
                    <Box sx={{ borderRadius: "200px", backgroundColor: mode === 'tab' ? colors.white : "#F2F4F7", padding: "8px", }}>
                        <TabsCustom
                            mode={mode}
                            sx={props.sx}
                            className={clsx('flex justify-center items-center', {
                                "border-b-1 border-b-slate-300": mode === 'tab'
                            })}
                            variant={"scrollable"}
                            scrollButtons={matchScreen}
                            TabIndicatorProps={{
                                hidden: true,
                                sx: {
                                    padding: 0,
                                }
                            }}
                            indicatorColor={'primary'}
                            allowScrollButtonsMobile
                            value={step}
                            onChange={handleChangeViewStep}
                            aria-label="custom tabs">
                            {stepLabel.map((list, index: number) => {
                                return (
                                    <Tab
                                        key={index}
                                        disabled={list.disabled}
                                        sx={{ textTransform: "none" }}
                                        iconPosition='start'
                                        icon={list.icon}
                                        label={list.name}
                                        {...a11yProps(index)}
                                    />
                                )
                            })}
                        </TabsCustom>
                    </Box>
                </Box>
            ) : (
                <MainStepper sx={props.sx} activeStep={step}>
                    {stepLabel.map((label, index) => {
                        const labelProps: {
                            optional?: React.ReactNode;
                            error?: boolean;
                        } = {};
                        return (
                            <CustomStep
                                onClick={() => {
                                    if (index !== 0) {
                                        if (index <= step || stepLabel[index]?.isAccept || stepLabel[index - 1]?.isAccept) {
                                            setStep(index)
                                        }
                                    } else {
                                        setStep(0);
                                    }
                                    return false
                                }} index={index} step={step} key={label.name}>
                                <CustomStepLabel {...labelProps} >
                                    {label.name}
                                </CustomStepLabel>
                            </CustomStep>
                        );
                    })}
                </MainStepper >
            )
            }

        </Box >
    );
})

export default StepperCustom